import { PriceCardProps } from "interface/PriceCardProps";

/**
 * goldPricePlan object defines the properties and features of the gold subscription plan.
 * It includes pricing details, a list of features, and a click handler for the subscription button.
 * 
 * @constant
 * 
 * @type {PriceCardProps}
 * 
 * @example
 * console.log(goldPricePlan.moreInfo);
 * // Output: "10 User Seats"
 * 
 * @see PriceCardProps - Interface representing the structure of a price plan.
 */
export const goldPricePlan : PriceCardProps = {
    subscriptionType: 'gold',
    moreInfo: '10 User Seats',
    price: '399.5',
    nonAfricanPrice: '799',
    subscriptionTerm: 'per month',
    features: ['Access to AI-Powered Workspace', '7 Workspace projects per user per month', 'Access to 7 report credits per month', 'On-demand training']
}